import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter039() {
  return <KbChapterPage slug="chapter-039" />;
}

(Chapter039 as unknown as { path: string }).path = "/theory-album/039";
